import {
  AfterViewInit, ChangeDetectorRef,
  Component, DoCheck,
  ElementRef,
  EventEmitter,
  Input, OnDestroy,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';
import {MatPaginator} from '@angular/material/paginator';
import {MatTableDataSource} from '@angular/material/table';
import {ParametrosTablaInterface} from '../../interfaces/parametros-tabla.interface';
import {ExportarExcel} from '../../utileria/exportar-tabla-excel';
import {NgxSpinnerService} from 'ngx-spinner';
import {EventosTablaInterface} from '../../interfaces/eventos-tabla.interface';
import {MatSort, Sort} from '@angular/material/sort';
import {LiveAnnouncer} from '@angular/cdk/a11y';
import {Constants} from '../../constants/constants';
import swal from 'sweetalert2';
import {TablaValidacionesService} from '../../services/tabla-validaciones.service';
import {Controles} from '../../constants/controles';
import {PageEvent} from '@angular/material/paginator';
import {MatInput} from '@angular/material/input';
import {AuthenticationService} from '../../services/authentication.service';
import {PreferencesUserInterface} from '../../interfaces/preferences-user.interface';
import {UspreferService} from '../../services/usprefer.service';
import {UtileriasService} from '../../services/utilerias.service';
import {ExportarExcelComponent} from '../exportar-excel/exportar-excel.component';
import {ToastrService} from 'ngx-toastr';
import {Subscription} from 'rxjs';
import {ListenerService} from '../../services/listener.service';


@Component({
  selector: 'app-tabla',
  templateUrl: './tabla.component.html',
  styleUrls: ['./tabla.component.scss']
})
export class TablaComponent implements OnInit, AfterViewInit, OnDestroy {

  @ViewChild('idpaginator') tablaPaginador: MatPaginator;
  @ViewChild('modalExportarExcel') modalExportarExcel: ExportarExcelComponent;

  @ViewChild(MatSort) sort: MatSort;

  @ViewChild('idExportar') table: ElementRef;
  @Input() parametrosTabla: ParametrosTablaInterface;

  @ViewChild(MatInput) matInput: MatInput;
  selectedRow: any = null;


  @Output() emitter: EventEmitter<EventosTablaInterface> = new EventEmitter<EventosTablaInterface>();
  dataSource: MatTableDataSource<any>;
  displayedColumns: string[];
  dataNames: string[];
  formatColumn: string[];
  pageSize: number;
  pageSizeOptions: number[];
  pageIndex: number = 0;
  intervalo: any;
  actualizarTabla = false;
  eventoTabla: EventosTablaInterface;
  iconos: string[] = ['ft-edit', 'ft-home', 'ft-phone', 'ft-folder', 'ft-eye', 'ft-trash', 'ft-user', 'ft-file-minus',
    'ft-file-text', 'ft-send', 'icon-envelope-open', 'ft-credit-card', 'ft-user-check', 'ft-book-open', 'ft-layers', 'ft-book', 'ft-users',
    'ft-dollar-sign', 'ft-upload', 'ft-circle', 'ft-check-circle', 'ft-x-square', 'ft-clock', 'ft-slack', 'ft-clipboard', 'ft-info',
    'ft-x-square', 'ft-message-circle', 'ft-database', 'ft-clipboard', 'ft-download', 'ft-shopping-cart', 'ft-archive', 'ft-map-pin', 'ft-search'];
  color: string[] = ['success', 'info', 'warning', 'danger', 'dark'];
  Control = Controles;
  isLoading = false;
  rightPanelStyle: any = {};
  optionSelectedMenuContext: any;
  pageEvent: PageEvent;
  filterSearch: string;
  preferenceUser: PreferencesUserInterface;
  secondHead = [];
  displayFooter = [];
  actualizarTablaSubscription: Subscription;

  constructor(private excel: ExportarExcel,
              private cd: ChangeDetectorRef,
              private spinner: NgxSpinnerService,
              private liveAnnouncer: LiveAnnouncer,
              public constants: Constants,
              private tablaValidaciones: TablaValidacionesService,
              private _usprefer: UspreferService,
              private authentication: AuthenticationService,
              private utileriasService: UtileriasService,
              private toastr: ToastrService,
              private listenerService: ListenerService) {
  }

  ngOnInit(): void {
    this.closeContextMenu();
    this.displayedColumns = this.parametrosTabla.displayedColumns;
    this.dataNames = this.parametrosTabla.dataNames;
    this.formatColumn = this.parametrosTabla.formatColumn;
    this.pageSizeOptions = this.parametrosTabla.pageSizeOptions;
    this.displayFooter = this.parametrosTabla.tipoFooter !== undefined ? this.parametrosTabla.tipoFooter : [];
    this.setPreferencePaginator();

    this.actualizarTablaSubscription = this.listenerService
      .on(this.constants.ACTUALIZAR_TABLA)
      .subscribe((tabla) => {
        if (tabla === this.parametrosTabla.tabla || tabla === undefined) {
          this.actualizaDatos(); // Tu método para recargar la tabla
        }
      });
  }

  ngOnDestroy(): void {
    this.actualizarTablaSubscription?.unsubscribe();
  }

  checkedBox(event: any, elemento: any) {
    if (event.target.checked) {
      elemento.selected = true;
    } else {
      elemento.selected = false;
    }
  }

  ngAfterViewInit(): void {
    return;
  }

  actualizaDatos(): void {

    this.isLoading = true;
    this.parametrosTabla.evento = {
      accion: ''
    };

    if (this.parametrosTabla.twoHeaders !== undefined && this.parametrosTabla.twoHeaders === true) {
      const colsp = this.parametrosTabla.beforeHeader.reduce((anterior, actual) => anterior + actual.colspan, 0)
      if (colsp < this.parametrosTabla.displayedColumns.length) {
        this.parametrosTabla.beforeHeader.push({titulo: '', colspan: this.parametrosTabla.displayedColumns.length - colsp})
      }
      this.secondHead = this.parametrosTabla.beforeHeader.map((value, index) => 'head2-' + value.titulo.split(' ').join('') + index)
    }

    this.displayFooter = this.parametrosTabla.tipoFooter !== undefined ? this.parametrosTabla.tipoFooter : [];

    this.intervalo = setTimeout(() => {

      this.displayedColumns = this.parametrosTabla.displayedColumns;
      this.dataNames = this.parametrosTabla.dataNames;
      this.formatColumn = this.parametrosTabla.formatColumn;
      this.dataSource = new MatTableDataSource(this.parametrosTabla.dataSource);
      this.setPreferencePaginator();
      this.pageSizeOptions.push(this.parametrosTabla.dataSource.length);
      this.tablaPaginador.pageSizeOptions = this.pageSizeOptions.filter((item, index) => this.pageSizeOptions.indexOf(item) === index);
      this.dataSource.paginator = this.tablaPaginador;
      this.dataSource.sort = this.sort;
      this.dataSource.filter = this.filterSearch;
      this.isLoading = false;

      this.cd.markForCheck();
    }, 300);


  }


  handlePage(e: any) {
    if (this.parametrosTabla.tabla !== undefined) {
      sessionStorage.setItem(this.parametrosTabla.tabla.toString(), this.utileriasService.encrypt(JSON.stringify(e)));
      this.updatePreferenceDataBase(e);
    }

    return e;
  }

  setPreferencePaginator() {
    if (this.parametrosTabla.tabla !== undefined && sessionStorage.getItem(this.parametrosTabla.tabla.toString()) != null) {
      const preferenceStorage = JSON.parse(this.utileriasService.decrypt(sessionStorage.getItem(this.parametrosTabla.tabla.toString())));
      if (preferenceStorage !== null) {
        this.pageSize = preferenceStorage.pageSize;
        this.pageIndex = preferenceStorage.pageIndex;

      } else {
        this.pageSize = this.parametrosTabla.pageSize;
        this.pageIndex = 0;
      }
    } else {
      this.pageSize = this.parametrosTabla.pageSize;
      this.pageIndex = 0;
    }
  }

  updatePreferenceDataBase(preferenceStorage): void {
    this.preferenceUser = {
      idusuari: this.authentication.idUsuario,
      tabla: this.parametrosTabla.tabla,
      preferencias: JSON.stringify(preferenceStorage)
    }

    this._usprefer.postUsprefer(this.preferenceUser).subscribe((_) => {
      this.cd.markForCheck();
    });
  }

  exportTable(): void {
    if (this.modalExportarExcel !== undefined) {
      this.modalExportarExcel.modalExportarExcel();
    } else {
      this.toastr.clear();
      this.toastr.error('No existen datos por exportar.', 'Exportar Excel');
    }
  }

  exportTableColumnas() {
    this.excel.exportarExcelColumnas(this.parametrosTabla.dataSourceGeneral, this.parametrosTabla.displayedColumnsExport);
  }

  filterTable(event: Event): void {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
    this.dataSource.filteredData.forEach((row) => row.selected = false);
    this.parametrosTabla.dataSource = this.dataSource.filteredData;
    this.filterSearch = this.dataSource.filter;
    this.updateTotal();
  }


  emit(evento: string, element?: any): void {
    switch (evento.trim()) {
      case this.constants.ACTUALIZAR_TABLA:
        this.eventoTabla = {
          accion: evento.trim()
        }
        this.actualizarTabla = true;
        break;
      case this.constants.DOCUMENTOS:
      case this.constants.PAGOS:
        this.eventoTabla = {
          accion: evento.trim(),
          objeto: element,
          tablaAdjuntos: this.parametrosTabla.tablaAdjuntos,
          rutaSFTP: this.parametrosTabla.rutaSFTP,
          tabla: this.parametrosTabla.tabla,
          comentarios: this.parametrosTabla.comentarios
        }
        break;
      case this.constants.ELIMINAR_DOCUMENTACION:
        this.eventoTabla = {
          accion: evento.trim(),
          objeto: element
        }
        this.emitter.emit(this.eventoTabla);
        break;
      case this.constants.ELIMINAR:
        this.eventoTabla = {
          accion: evento.trim(),
          objeto: element
        }
        this.deleteConfirm(this.eventoTabla);
        break;
      case this.constants.FUSIONAR:
        const result = this.dataSource.filteredData.filter((row) => row.selected === true);
        this.eventoTabla = {
          accion: evento.trim(),
          objeto: result
        }
        break;
      default:
        this.eventoTabla = {
          accion: evento.trim(),
          objeto: element
        }
        break;
    }

    if (evento !== this.constants.ELIMINAR) {
      this.emitter.emit(this.eventoTabla);
    }

  }


  setIconColumn(columna): string {
    const estilo = ' font-medium-1 ';

    switch (columna.trim()) {
      case this.constants.EDITAR:
        return this.iconos[0] + estilo + this.color[1];
        break;
      case this.constants.DOMICILIOS:
        return this.iconos[1] + estilo + this.color[2];
        break;
      case this.constants.CONTACTOS:
        return this.iconos[2] + estilo + this.color[0];
        break;
      case this.constants.DOCUMENTOS:
        return this.iconos[3] + estilo + this.color[4];
        break;
      case this.constants.VISUALIZAR:
        return this.iconos[4] + estilo + this.color[1];
        break;
      case this.constants.ELIMINAR:
      case this.constants.ELIMINAR_DOCUMENTACION:
        return this.iconos[5] + estilo + this.color[3];
        break;
      case this.constants.CLIENTES:
        return this.iconos[6] + estilo + this.color[2];
        break;
      case this.constants.XML:
      case this.constants.NOTA_CREDITO:
        return this.iconos[7] + estilo + this.color[2];
        break;
      case this.constants.PDF:
      case this.constants.CONSTANCIA:
        return this.iconos[8] + estilo + this.color[0];
        break;
      case this.constants.DETALLES:
        return this.iconos[8] + estilo + this.color[2];
        break;
      case this.constants.EMAIL:
        return this.iconos[9] + estilo + this.color[4];
        break;
      case this.constants.NOTIFICADO:
        return this.iconos[10] + estilo + this.color[2];
        break;
      case this.constants.NOTIFICADO_ANTICIPO:
        return this.iconos[10] + estilo + this.color[1];
        break;
      case this.constants.CUENTAS_BANCARIAS:
        return this.iconos[11] + estilo + this.color[3];
        break;
      case this.constants.INMUEBLES:
        return this.iconos[1] + estilo + this.color[0];
        break;
      case this.constants.PROPIETARIOS:
        return this.iconos[12] + estilo + this.color[2];
        break;
      case this.constants.CONDICIONES:
        return this.iconos[13] + estilo + this.color[2];
        break;
      case this.constants.CONTRATOS:
        return this.iconos[14] + estilo + this.color[2];
        break;
      case this.constants.CONVENIOS:
        return this.iconos[15] + estilo + this.color[2];
        break;
      case this.constants.ARRENDADORES:
        return this.iconos[16] + estilo + this.color[2];
        break;
      case this.constants.FACTURACION_CONDICIONES:
        return this.iconos[17] + estilo + this.color[2];
        break;
      case this.constants.PAGADO:
      case this.constants.VENDIDO:
      case this.constants.PAGOS:
        return this.iconos[17] + estilo + this.color[0];
        break;
      case this.constants.UPLOAD_FACTURA:
        return this.iconos[18] + estilo + this.color[0];
        break;
      case this.constants.VALIDAR:
        return this.iconos[19] + estilo + this.color[1];
        break;
      case this.constants.REVISADO:
        return this.iconos[20] + estilo + this.color[0];
        break;
      case this.constants.CANCELAR:
        return this.iconos[21] + estilo + this.color[3];
        break;
      case this.constants.RELOJ:
        return this.iconos[22] + estilo + this.color[3];
        break;
      case this.constants.CUENTAS_CONTABILIDAD:
        return this.iconos[23] + estilo + this.color[4];
        break;
      case this.constants.REQUISICION:
        return this.iconos[24] + estilo + this.color[4];
        break;
      case this.constants.VALIDAR_CFDI:
        return this.iconos[25] + estilo + this.color[4];
        break;
      case this.constants.CANCELAR_CFDI:
        return this.iconos[26] + estilo + this.color[2];
        break;
      case this.constants.TERCEROS:
        return this.iconos[16] + estilo + this.color[2];
        break;
      case this.constants.SOLICITUD:
        return this.iconos[8] + estilo + this.color[0];
        break;
      case this.constants.NOTAS:
        return this.iconos[27] + estilo + this.color[1];
        break;
      case this.constants.CUENTAS_CONTABLES:
        return this.iconos[28] + estilo + this.color[1];
        break;
      case this.constants.INFORMACION_GENERAL:
        return this.iconos[29] + estilo + this.color[1];
        break;
      case this.constants.FORMATO_IDENTIFICACION:
        return this.iconos[12] + estilo + this.color[0];
        break;
      case this.constants.DESCARGAR_ADJUNTOS:
        return this.iconos[30] + estilo + this.color[4];
        break;
      case this.constants.ODC:
        return this.iconos[31] + estilo + this.color[1];
        break;
      case this.constants.HISTORIAL_PAGOS:
        return this.iconos[32] + estilo + this.color[0];
        break;
      case this.constants.MAPA:
        return this.iconos[33] + estilo + this.color[0];
        break;
      case this.constants.PPE:
        return this.iconos[34] + estilo + this.color[0];
        break;
      case this.constants.EMPRESAS:
        return 'bi bi-building-check' + estilo + this.color[1];
        break;
      case this.constants.PERMISOS:
        return 'bi bi-shield-fill-check' + estilo + this.color[0];
        break;
      case this.constants.RESET_PASSWORD:
        return 'bi bi-key-fill' + estilo + this.color[2];
        break;
      case this.constants.PAGOS_AMORTIZABLES:
        return 'bi bi-list-check' + estilo + this.color[2];
        break;
      case this.constants.SUBDIVISION:
        return 'bi bi-arrows-angle-expand' + estilo + this.color[2];
        break;
      case this.constants.FUSION:
        return 'bi bi-arrows-angle-contract' + estilo + this.color[1];
        break;
      default:
        return '';
        break;
    }
  }

  announceSortChange(sortState: Sort) {
    if (sortState.direction) {
      this.liveAnnouncer.announce(`Sorted ${sortState.direction}ending`);
    } else {
      this.liveAnnouncer.announce('Sorting cleared');
    }
  }

  setBackground(dataSource: any, column: any): string {
    return this.tablaValidaciones.setStyleColumn(this.parametrosTabla.tabla, dataSource, column);
  }

  displayColumn(dataSource: any, column: any): boolean {
    return this.tablaValidaciones.setDisplayColumn(this.parametrosTabla.tabla, dataSource, column, this.parametrosTabla.documentacion);
  }

  isGranted(column: any) {
    return this.tablaValidaciones.isGranted(this.parametrosTabla.tabla, column, this.parametrosTabla.documentacion);
  }

  deleteConfirm(evento: any): any {
    swal.fire({
      title: '¿Desea eliminar el registro seleccionado?',
      text: '¡No podrás revertir esto!',
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sí, continuar',
      cancelButtonText: 'Cancelar'
    }).then((result) => {
        if (result.isConfirmed) {
          this.eventoTabla = {
            accion: evento.accion,
            objeto: evento.objeto
          }
          this.emitter.emit(this.eventoTabla);
        }
      }
    );
  }

  displayCurrency(dataSource: any, column: any): boolean {
    return this.tablaValidaciones.displayCurrency(this.parametrosTabla.tabla, dataSource, column);
  }

  detectRightMouseClick(event: any, element: any): void {
    if (event.button == 2) {
      this.optionSelectedMenuContext = element;
      this.rightPanelStyle = {
        'display': 'block',
        'position': 'absolute',
        'left.px': event.layerX,
        'top.px': event.layerY
      }
    }
  }

  closeContextMenu() {
    this.rightPanelStyle = {
      'display': 'none',
    }
  }

  displayOptionMenuContext(columna: any) {
    return this.displayColumn(this.optionSelectedMenuContext, columna);
  }

  sumTotal(column: string) {

    // obtener la columna sin sufijos o transformaciones (como en el original)
    const colKey = column.split('_')[0];

    // Filtrado y paginación aplicada: dataSource.filteredData es lo filtrado
    // Si quieres solo la página visible, usar dataSource._renderData.value (pero _renderData es privado)
    const data = this.parametrosTabla.dataSource;

    return data.reduce((acc, item) => acc + (Number(item[colKey]) || 0), 0);
  }

  updateTotal() {

  }

  obtenerMax(colum: string) {
    return Math.max(...this.parametrosTabla.dataSource.map(value => value[colum.split('_')[0]]));
  }

  obtenerMin(colum: string) {
    return Math.min(...this.parametrosTabla.dataSource.map(value => value[colum.split('_')[0]]));
  }

  imprimirTabla(): void {

    const tableHtml = this.table.nativeElement.innerHTML;

    const printWindow = window.open('', '_blank');
    printWindow?.document.write(`
      <html>
        <head>
          <title>Imprimir Tabla</title>
          <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.3/dist/css/bootstrap.min.css" rel="stylesheet" integrity="sha384-QWTKZyjpPEjISv5WaRU9OFeRpok6YctnYmDr5pNlyT2bRjXh0JMhjY6hW+ALEwIH" crossorigin="anonymous">
          <style>
            table { width: 100%; border-collapse: collapse; }
            table, th, td { border: 1px solid black; font-size: 12px; }
            th, td { padding: 1px; text-align: left; font-size: 9px; }
            .ignoreprint {display: none; }
          </style>
        </head>
        <body>
          ${tableHtml}
        </body>
      </html>
    `);

    printWindow.document.close();
    printWindow.onload = () => {
      printWindow.print();
      // Cierra la ventana después de la impresión
      printWindow.close();
    };

  }


}
